import { Icons } from '@/components/Shares/Icons';
import { useModalAction } from '@/providers/ModalActionProvider';
import { Grid, Group, Tabs } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
export const AsideTabControl: React.FC = () => {
  const isMobile = useMediaQuery('(max-width: 36em)');
  const {
    setOpenModal
  } = useModalAction();
  return <Group justify="center" p={{
    base: 10,
    sm: 14
  }} bg="#272E34" w="100%" style={{
    borderRadius: isMobile ? 0 : 5
  }}>
      <Tabs.List w="100%">
        <Grid gutter={10} w="100%">
          <Grid.Col span={3}>
            <Tabs.Tab value="chat">
              <Icons className="icon-pr-flat-chat-bubble" fontSize={19} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={3}>
            <Tabs.Tab value="battle">
              <Icons className="icon-pr-flat-vs" fontSize={19} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={3}>
            <Tabs.Tab value="challenges">
              <Icons className="icon-pr-flat-swords" fontSize={19} />
            </Tabs.Tab>
          </Grid.Col>
          <Grid.Col span={3}>
            <Tabs.Tab value="exit" onClick={() => setOpenModal(null)}>
              <Icons className="icon-pr-flat-exit" fontSize={19} />
            </Tabs.Tab>
          </Grid.Col>
        </Grid>
      </Tabs.List>
    </Group>;
};